export default function badge({ variables }) {
    return {
        MuiBadge: {
            styleOverrides: {
                badge: {
                    fontSize: variables.type_micro_font_size,
                    fontWeight: variables.font_weight_semibold,
                    minWidth: 18,
                    height: 18,
                    padding: `0 ${variables.spacing_02}`,
                    borderRadius: variables.border_radius_small,
                },
                dot: {
                    minWidth: 6,
                    height: 6,
                    borderRadius: variables.border_radius_pill,
                },
            },
        },
    };
}
//# sourceMappingURL=badge.js.map